import React, { useEffect, useState } from "react";
import { Col, Dropdown, Row } from "react-bootstrap";
import styles from "./Timeslot.module.scss";
import TimeSlotPhysician from "../physicianInfo/timeslotPhysician";
import { MdBlock } from "react-icons/md";
const Timeslot = ({
  activeTab,
  handleTabChange,
  modalIsOpen,
  setModalIsOpen,
  slotFormData,
  setSlotFormData,
  handleSlotChange,
  physicianInfo,
  handleClinicChange,
  handleSlotSave,
  getPhysicianDetailsByClinic,
  handleSlotStatus,
}) => {
  const [selectedClinicId, setSelectedClinicId] = useState(null);
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  useEffect(() => {
    if (physicianInfo?.asociatedClinic?.length && !selectedClinicId) {
      const firstClinic = physicianInfo.asociatedClinic[0]?.clinicId?._id;
      const firstClinicName =
        physicianInfo.asociatedClinic[0]?.clinicId?.clinicName;
      const firstClinicUserId =
        physicianInfo.asociatedClinic[0]?.clinicId?.userId;
      setSelectedClinicId(firstClinic);
      handleClinicChange(firstClinic, firstClinicName, firstClinicUserId);
    }
  }, [physicianInfo, selectedClinicId, handleClinicChange]);

  const getFilteredSessionsByDay = (dayName) => {
    return getPhysicianDetailsByClinic?.flatMap((phyDetail) =>
      phyDetail?.asociatedClinic?.flatMap((clinicArr) =>
        clinicArr?.timeSlot?.flatMap((timeSlotArr) =>
          timeSlotArr?.dayName === dayName ? timeSlotArr?.timeOfTheDay : []
        )
      )
    );
  };
  const filteredSessionsByDay = getFilteredSessionsByDay(activeTab);
  return (
    <>
      <div className="d-flex justify-content-between mt-4">
        <div className="d-flex gap-3">
          {physicianInfo?.asociatedClinic?.map((clinic, i) => (
            <div
              className={`${styles.clinicname} ${
                selectedClinicId === clinic?.clinicId?._id
                  ? styles.activeClinic
                  : ""
              }`}
              key={i}
            >
              <input
                type="radio"
                name="SelectedClinic"
                checked={selectedClinicId === clinic?.clinicId?._id}
                className={styles.radio}
                onChange={() => {
                  setSelectedClinicId(clinic?.clinicId?._id);
                  handleClinicChange(
                    clinic?.clinicId?._id,
                    clinic?.clinicId?.clinicName,
                    clinic?.clinicId?.userId
                  );
                }}
              />
              <span className={styles.name}>
                {clinic?.clinicId?.clinicName}
              </span>
            </div>
          ))}
        </div>
        {slotFormData.clinicId && (
          <div
            className="btn btn-primary btn-rounded"
            onClick={() => setModalIsOpen(true)}
          >
            + Add Slot
          </div>
        )}
      </div>

      <div className={styles.timeslotContainer}>
        <div className={styles.timeslotTabs}>
          {getPhysicianDetailsByClinic?.map((clinic, i) =>
            clinic?.asociatedClinic?.map((slot, j) =>
              slot?.timeSlot?.map((day, i) => (
                <button
                  key={i}
                  className={`${styles.tab} ${
                    activeTab === day.dayName ? styles.active : ""
                  }`}
                  onClick={() => handleTabChange(day.dayName, day.slotSession)}
                >
                  {day.dayName}
                </button>
              ))
            )
          )}
        </div>
        <Row>
          {filteredSessionsByDay?.map((sessionArr, i) => (
            <>
              <Col md={6}>
                <div className={styles.timeslotPeriods}>
                  <h4 key={i}>{sessionArr?.sessionName}</h4>
                  <div className={styles.slotGrid}>
                    <div className={styles.slotColumn}>
                      <div className={styles.slotContent}>
                        <table className={styles.slotTable}>
                          <thead className={styles.slotTableHead}>
                            <tr>
                              <th className={styles.slotHeader}>Slot</th>
                              <th>Waiting Time</th>
                              <th>Appt Type</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody className={styles.slotTableBody}>
                            {sessionArr?.sessionTime?.map((timeSlot, index) => (
                              <tr
                                key={index}
                                className={
                                  timeSlot?.slotStatus === "Unavailable"
                                    ? styles.unavailableSlot
                                    : ""
                                }
                              >
                                <td
                                  className={`${styles.slotTd} ${
                                    timeSlot?.slotStatus === "Unavailable"
                                      ? styles.disabledText
                                      : ""
                                  }`}
                                >
                                  {timeSlot?.slotTime}
                                </td>
                                <td>{sessionArr?.waitingTime} mins</td>
                                <td>{sessionArr?.consultationType}</td>
                                <td className={styles.svgTd}>
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      variant="success"
                                      className="light sharp i-false"
                                    >
                                      {svg1}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        // onClick={(e) => {
                                        //   handleEdit();
                                        //   e.stopPropagation();
                                        // }}
                                        onClick={() => {
                                          handleSlotStatus({
                                            physicianId:
                                              physicianInfo?.physicianId,
                                            slotId: timeSlot?._id,
                                            clinicId: selectedClinicId,
                                            slotStatus:
                                              timeSlot?.slotStatus ===
                                              "Unavailable"
                                                ? "Available"
                                                : "Unavailable",
                                          });
                                        }}
                                      >
                                        <MdBlock
                                          size={18}
                                          className={`me-1 ${
                                            timeSlot?.slotStatus ===
                                            "Unavailable"
                                              ? "text-success"
                                              : "text-secondary"
                                          }`}
                                        />
                                        {timeSlot?.slotStatus === "Unavailable"
                                          ? "Unblock"
                                          : "Block"}
                                      </Dropdown.Item>
                                      {/* <Dropdown.Item
                                      // onClick={(e) => {
                                      //   handleDelete();
                                      //   e.stopPropagation();
                                      // }}
                                      >
                                        <FaTrashCan
                                          size={14}
                                          className="me-1 text-danger"
                                        />{" "}
                                        Delete
                                      </Dropdown.Item> */}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </>
          ))}
        </Row>
        <TimeSlotPhysician
          modalIsOpen={modalIsOpen}
          setModalIsOpen={setModalIsOpen}
          activeTab={activeTab}
          slotFormData={slotFormData}
          setSlotFormData={setSlotFormData}
          handleSlotChange={handleSlotChange}
          handleSlotSave={handleSlotSave}
        />
      </div>
    </>
  );
};

export default Timeslot;
